/**
 * Chain plumbing for the wallet layer, import-free so the wallet modules can
 * pull from here without a cycle. No chain fact a page shows or acts on comes
 * from here: chain ids come from each gateway's descriptor, labels from
 * `/chains.json` or the session.
 */

/** 8453 -> "0x2105" (the form the wallet RPCs expect). */
export function toChainIdHex(chainId: number): string {
  return `0x${chainId.toString(16)}`;
}

// ---- chain names --------------------------------------------------------------

const names = new Map<number, string>();

/** Records the runtime name of `chainId` ("Base", "BSC"): a `/chains.json` label, or the network a page acts on. */
export function nameChain(chainId: number, label: string): void {
  if (label !== "") names.set(chainId, label);
}

/** The runtime name of `chainId` for the wallet's messages, else "chain 56". */
export function chainLabel(chainId: number): string {
  return names.get(chainId) ?? `chain ${chainId}`;
}

/** Tests only: forget every recorded name. */
export function resetChainNames(): void {
  names.clear();
}
